


import { ISelectOption } from "../dtos/SelectOptionDto";
enum WorkersCompCodes {
        Item1 = 0,
        Item2 = 1,
        Item3 = 2,
        Item4 = 3,
        Item5 = 4,
        Item6 = 5,
         
}

export class WorkersCompCodes_class {

public static enum = WorkersCompCodes;

  public static readonly enumByText : { [key : string ]: number} = {
    ['Item1']: 0,
    ['Item2']: 1,
    ['Item3']: 2,
    ['Item4']: 3,
    ['Item5']: 4,
    ['Item6']: 5,
    
  };
  public static readonly enumByNumber : { [key : number ]: string} = {
    [0]: "1- Total Temporary",
    [1]: "2- Partial Temporary",
    [2]: "3- Total Permanent",
    [3]: "4- Partial Permanent",
    [4]: "5- Other",
    [5]: "6- Unknown",
    
  };

  public static readonly enumAsSelectOptions:Array<ISelectOption<number>> = [
  {value: 0, text: "1- Total Temporary"},
  {value: 1, text: "2- Partial Temporary"},
  {value: 2, text: "3- Total Permanent"},
  {value: 3, text: "4- Partial Permanent"},
  {value: 4, text: "5- Other"},
  {value: 5, text: "6- Unknown"},
  ]
}

